import React from 'react'

const TeamMembers = ({aboutUsMembersData}) => {
    const {_id, name, image, role} = aboutUsMembersData;
  return (
    <div>
        <h1>{name}</h1>
        <img src={image} alt="" />
    </div>
  )
}

export default TeamMembers;